export default ({ date, language, type = 'date' }) => {
	if(!date) {
		return ''
	}

	let locales
	switch (language) {
		case 'Italian':
		case 'German': locales = 'de-CH'
			break
		case 'English': locales = 'eng'
			break
		default: locales = 'de-DE'
	}

	return type === 'date'
		? new Date(date).toLocaleDateString(locales, { timeZone: 'UTC', day: '2-digit', year: 'numeric', month: '2-digit' })
		: new Date(date).toLocaleTimeString(locales, { timeZone: 'UTC' })
}
